export const CometChat = () => {
	const regID = window.dataLayer[0]["Registrant ID"]
	const userName = window.dataLayer[0]["First & Last Name"]
	const picture = "https://media-exp1.licdn.com/dms/image/C4D0BAQE2u4Sjv5Klcw/company-logo_200_200/0/1576175308932?e=2159024400&v=beta&t=jrKRCqN78jt4947HCyNtw41wXEfRyRxN8-byEqkgJ1g"
	const regUid = regID.toString()

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			height: "550px",
			// left or right
			roundedCorners: "true",

			widgetID: "f98de5d2-7eb9-4cb4-8e74-6aa52f050d87",
			width: "400px",
		})
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = () => {
		window.CometChatWidget.init({
			appID: "217253d380495325",
			appRegion: "us",
			authKey: "b0862d7963e9e833d5c6d08ead5edcc160bcf758",
		}).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v3/cometchatwidget.js" />
}
